import { render, staticRenderFns } from "./uploadProof.vue?vue&type=template&id=e5ae7d0a&scoped=true"
import script from "./uploadProof.vue?vue&type=script&lang=js"
export * from "./uploadProof.vue?vue&type=script&lang=js"
import style0 from "./uploadProof.vue?vue&type=style&index=0&id=e5ae7d0a&prod&lang=scss"
import style1 from "./uploadProof.vue?vue&type=style&index=1&id=e5ae7d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ae7d0a",
  null
  
)

export default component.exports